import React, { lazy, Suspense, useEffect, useState } from "react";
import { Product } from "../../utiles/types";
import { GiClothes, GiDiamondRing, GiNecklace, GiBracer, GiGemChain } from "react-icons/gi";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import necklace1 from '../../asset/maysam_image/necklace1.png';
import ring1 from '../../asset/maysam_image/ring1.png';
import bracelet1 from '../../asset/maysam_image/bracelet1.png';
import set1 from '../../asset/maysam_image/set.png';
const ProductCard = lazy(() => import("../../utiles/Cards/ProductCard"));


interface CategorySectionProps {
  exploreProducts: Product[];
  wishlist: Product[];
  handleNavigate: (path: string) => void;
  toggleWishlist: (product: Product) => void;
}

const CategorySection: React.FC<CategorySectionProps> = ({
  exploreProducts,
  handleNavigate,
  wishlist,
  toggleWishlist,
}) => {
    const [data, setData] = React.useState<any>([]);
    const [displayedText, setDisplayedText] = useState('');
    const [slideIndex, setSlideIndex] = useState(0);
    const fullText = "Discover timeless elegance with our handcrafted jewellery collections. From classic pieces to modern designs, each item is crafted with precision and passion. Elevate your everyday look or find the perfect piece for life's most special moments. Shine with beauty that lasts.";
    const images = [necklace1, ring1, bracelet1, set1];
    const arrangements = [
      [0, 1, 2, 3], // original
      [1, 0, 3, 2], // swapped
      [2, 3, 0, 1], // rotated
      [3, 2, 1, 0], // reversed
    ];
  const navigate = useNavigate();
  const handleNavigate2 = (path: string) => navigate(path);
  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
    // Fetch or set up your data here
    setData(exploreProducts.slice(0, 4));
}, [exploreProducts]);

useEffect(() => {
  let index = 0;
  const timer = setInterval(() => {
    if (index < fullText.length) {
      setDisplayedText(fullText.slice(0, index + 1));
      index++;
    } else {
      clearInterval(timer);
    }
  }, 50); // Adjust speed here (50ms per character)

  return () => clearInterval(timer);
}, []);

useEffect(() => {
  const slideTimer = setInterval(() => {
    setSlideIndex((prevIndex) => (prevIndex + 1) % arrangements.length);
  }, 4000); // Change slide every 4 seconds

  return () => clearInterval(slideTimer);
}, []);

// console.log("CategorySection data:", data);

  const currentArrangement = arrangements[slideIndex];

  return (
    <section className="py-12 bg-gradient-to-br from-gray-50 to-white shadow-lg">
      <div className="container mx-auto px-4 max-w-[1400px]">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800 mb-4 flex items-center justify-center gap-2">
            <GiGemChain className="text-5xl text-yellow-500" />
            Explore Our Collections
            <GiGemChain className="text-5xl text-yellow-500" />
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Indulge in the artistry of handcrafted jewelry that tells your unique story. From delicate necklaces to stunning rings, each piece is a masterpiece waiting to adorn you.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
            {/* Left Side - Featured Jewelry */}
            <div className="text-center lg:text-right flex flex-col justify-center items-center lg:items-end space-y-6">
                <div className="overflow-hidden rounded-lg shadow-2xl" data-aos="fade-right" data-aos-delay="100">
                  <img src={images[currentArrangement[0]]} className="h-[24rem] w-[18rem] object-cover transition-all duration-500 hover:scale-110 hover:shadow-2xl" alt="Featured Necklace" />
                  {/* <div className="mt-2 text-sm font-semibold text-gray-600">Elegant Necklace</div> */}
                </div>
                <div className="overflow-hidden rounded-lg shadow-2xl" data-aos="fade-up" data-aos-delay="200">
                  <img src={images[currentArrangement[1]]} className="h-[20rem] w-[15rem] object-cover transition-all duration-500 hover:scale-110 hover:shadow-2xl" alt="Stunning Ring" />
                  {/* <div className="mt-2 text-sm font-semibold text-gray-600">Signature Ring</div> */}
                </div>
            </div>

            {/* Center - Main Content */}
            <div className="text-center flex flex-col items-center space-y-6">
                <div data-aos="zoom-in" data-aos-delay="300" className="text-gray-700 text-lg leading-relaxed max-w-lg">
                  <GiGemChain className="inline text-3xl text-yellow-500 mx-2" />
                  {displayedText}
                  <GiGemChain className="inline text-3xl text-yellow-500 mx-2" />
                </div>

                <div className="bg-white rounded-full p-6 shadow-xl" data-aos="fade-in" data-aos-delay="400">
                  <GiDiamondRing className="text-6xl text-blue-500 animate-pulse" />
                </div>

                <div data-aos="fade-in" data-aos-delay="500" className="text-gray-700 text-base leading-relaxed max-w-md">
                  <GiNecklace className="inline text-xl text-purple-500 mr-2" />
                  Jewelry designed to be worn every day. Simple, stylish, and thoughtfully crafted, our pieces bring a touch of modern elegance to your style.
                  <br /><br />
                  <GiBracer className="inline text-xl text-green-500 mr-2" />
                  Discover the perfect blend of tradition and innovation. Our curated selection offers something for every occasion, ensuring you always shine with confidence.
                </div>
            </div>

            {/* Right Side - More Jewelry */}
            <div className="text-center lg:text-left flex flex-col justify-center items-center lg:items-start space-y-6">
                <div className="overflow-hidden rounded-lg shadow-2xl" data-aos="fade-left" data-aos-delay="600">
                  <img src={images[currentArrangement[2]]} className="h-[20rem] w-[15rem] object-cover transition-all duration-500 hover:scale-110 hover:shadow-2xl" alt="Beautiful Bracelet" />
                  {/* <div className="mt-2 text-sm font-semibold text-gray-600">Delicate Bracelet</div> */}
                </div>
                <div className="overflow-hidden rounded-lg shadow-2xl" data-aos="fade-up" data-aos-delay="700">
                  <img src={images[currentArrangement[3]]} className="h-[24rem] w-[18rem] object-cover transition-all duration-500 hover:scale-110 hover:shadow-2xl" alt="Complete Set" />
                  {/* <div className="mt-2 text-sm font-semibold text-gray-600">Complete Jewelry Set</div> */}
                </div>
            </div>
        </div>

        {/* Additional Catchy Elements */}
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
          <div className="bg-white rounded-lg p-4 shadow-md hover:shadow-lg transition-shadow" data-aos="fade-up" data-aos-delay="800">
            <GiDiamondRing className="text-3xl text-blue-500 mx-auto mb-2" />
            <div className="text-sm font-semibold text-gray-700">Premium Quality</div>
          </div>
          <div className="bg-white rounded-lg p-4 shadow-md hover:shadow-lg transition-shadow" data-aos="fade-up" data-aos-delay="900">
            <GiNecklace className="text-3xl text-purple-500 mx-auto mb-2" />
            <div className="text-sm font-semibold text-gray-700">Handcrafted</div>
          </div>
          <div className="bg-white rounded-lg p-4 shadow-md hover:shadow-lg transition-shadow" data-aos="fade-up" data-aos-delay="1000">
            <GiBracer className="text-3xl text-green-500 mx-auto mb-2" />
            <div className="text-sm font-semibold text-gray-700">Timeless Design</div>
          </div>
          <div className="bg-white rounded-lg p-4 shadow-md hover:shadow-lg transition-shadow" data-aos="fade-up" data-aos-delay="1100">
            <GiGemChain className="text-3xl text-yellow-500 mx-auto mb-2" />
            <div className="text-sm font-semibold text-gray-700">Unique Pieces</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CategorySection;




// {exploreProducts.slice(0, 4).map((product) => (